import React from 'react';
import MarkdownDialog from '@/components/dialogs/MarkdownDialog';
import Selectors from '../hooks/selectors';
import Events from '../hooks/events';

const WorkspaceRequestDialog = ({ theme }) => {
  const { name, text } = Selectors.useWorkspaceRequestDialog();
  const hide = Events.useHideWorkspaceRequestReceipt();

  return (
    <MarkdownDialog
      className="aridhia-workspace-request-dialog"
      hide={hide}
      modalIcon="cube"
      name={name}
      suffix="_request_workspace"
      text={text}
      theme={theme}
    />
  );
};

export default WorkspaceRequestDialog;
